import { Link } from "react-router-dom";

const Visatronix = () => {
    return (
        
        <div>
            <div className="flex flex-col justify-center items-center">
                <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
                <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
            
                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                            Visatronix
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                            TCS Visatronix provides a hassle-free, one window, visa dropbox and value-added visa 
                            facilitation services. Operating from eleven major cities of Pakistan, with a dedicated 
                            team of courteous and experienced visa services officers, we manage over 100,000 visa 
                            applications annually. To offer further convenience, applications are booked 
                            on a ‘Return Service Basis ’at selected TCS Express Centres located in all major 
                            cities of Pakistan. The ever increasing list of destinations currently serves Egypt, 
                            Greece, India, Italy, Malaysia, Malta, South Africa, Spain, Thailand and Tunisia.
                        </p>
                        
                            
                        <div className=" mt-[1rem] w-[100%]">
                        
                            <div className="flex justify-left">
                                <Link to="/visatronix" className="flex justify-center text-center items-center rounded-sm h-9 mt-[2px] text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Find Out More</Link>
                            
                            </div>
                        </div>
                        
                    </div>
                    <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
                        <img src="/international-banner/image-5.jpg" alt="" className="rounded-md w-[100%]"/>
                    </div>
                </div>
               
            </div>
            
            
        </div>
       
    )
};
export default Visatronix;